<template>
  <div id="app">
    <HeaderCompo />
    <template>
      <div
        id="about_page"
        class="container"
      >
        <div class="box about">
          <center>
            <h3 id="about_title">
              Privacy Policy and Disclaimers
            </h3>
            <h4 style="margin-bottom: 20px;">
              Effective as of July 2026
            </h4>
            <h2>Advertising. </h2>
            <p>
              CMI Marketing, Inc., d/b/a Raptive (“Raptive”) is a service provider of this Site for the purposes of placing advertising on the Site, and Raptive will collect and use certain data for advertising purposes. To learn more about Raptive’s data usage, click here: <a href="https://raptive.com/creator-advertising-privacy-statement" target="_blank" rel="noreferrer noopener">https://raptive.com/creator-advertising-privacy-statement</a>
            </p>
            <h3>1. Acceptance of Terms</h3>
            <p>Welcome to Bestiefy! These Terms of Service ("Terms") govern your access to and use of bestiefy.com (the "Service"), operated by Bestiefy ("we," "us," or "our"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the Service.<br></br>
We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting. Your continued use of the Service after changes are posted constitutes your acceptance of the modified Terms.</p>
            <h3>2. Description of Service</h3>
            <p>Bestiefy is a free online quiz generation platform that allows users to:<br><br>

Create custom quizzes with questions and answers.<br>
Share quizzes with others through unique links.<br>
Take quizzes created by other users.<br>
View quiz results and responses.<br><br>

The Service is supported by advertising and is provided free of charge.</p>
            <h3>3. Eligibility</h3>
            <p>You must be at least 13 years of age to use the Service. By using the Service, you represent and warrant that you are at least 13 years old. If you are under 18, you must have permission from a parent or legal guardian to use the Service.</p>
            <h3>4. User Accounts and Anonymous Use</h3>
              <p>Bestiefy allows anonymous use. You do not need to create an account to create or take quizzes. However, quiz results and participant names will be stored and visible to quiz creators and participants as described in our Privacy Policy.</p>
              <h2>5. User-Generated Content</h2>
              <h3>5.1 Content Ownership</h3>
              <p>You retain all ownership rights to the quizzes, questions, answers, and other content you create on Bestiefy ("Your Content"). By creating content on the Service, you grant us a non-exclusive, worldwide, royalty-free license to host, store, display, and distribute Your Content solely for the purpose of operating and providing the Service.</p>
              <h3>5.2 Content Responsibility</h3>
              <p>You are solely responsible for Your Content and the consequences of posting or publishing it. By creating content on Bestiefy, you represent and warrant that:<br><br>

You own or have the necessary rights to use and authorize us to use Your Content.<br>
Your Content does not infringe, violate, or misappropriate any third-party rights, including copyright, trademark, privacy, or other intellectual property rights.<br>
Your Content complies with these Terms and all applicable laws.<br></p>
                <h3>5.3 Content Restrictions</h3>
                <p>You agree not to create, upload, or share content that:<br><br>

Is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, or otherwise objectionable.<br>
Infringes any patent, trademark, trade secret, copyright, or other intellectual property rights.<br>
Contains viruses, malware, or other harmful computer code.<br>
Promotes discrimination, bigotry, racism, hatred, harassment, or harm against any individual or group.<br>
Promotes illegal activities or violates any laws or regulations.<br>
Contains sexually explicit content or content harmful to minors.<br>
Impersonates any person or entity or misrepresents your affiliation with any person or entity.<br>
Collects or harvests personal information from other users.<br>
Is spam, promotional material, or advertising (except as permitted by us).<br></p>

            <h2>6. Quiz Sharing and Results</h2>
            <h3>6.1 Quiz Visibility</h3>
            <p>When you create a quiz on Bestiefy, you can share it with others through a unique link. Anyone with the link can take your quiz.</p>
            <h3>6.2 Results Access</h3>
            <p>Quiz creators can view all results and responses from participants.<br>
Participants can view their own quiz results.<br>
Participant names provided when taking a quiz will be visible to the quiz creator and may be visible to other participants.<br>
Quiz results are stored for up to one year, after which they are automatically deleted.</p>
              <h3>6.3 Quiz Deletion</h3>
              <p>You may delete quizzes you have created at any time. Deleting a quiz will remove it from our Service, but may not immediately delete cached or backup copies.</p>
              <h3>7. Prohibited Uses</h3>
              <p>In addition to content restrictions, you agree not to:<br><br>

Use the Service for any illegal purpose or to violate any laws.<br>
Attempt to gain unauthorized access to any portion of the Service or any other systems or networks.<br>
Interfere with or disrupt the Service or servers or networks connected to the Service.<br>
Use any robot, spider, scraper, or other automated means to access the Service.<br>
Attempt to decipher, decompile, disassemble, or reverse engineer any of the software comprising the Service.<br>
Remove any copyright, trademark, or other proprietary notices from the Service.<br>
Frame or mirror any part of the Service without our prior written authorization.<br>
Create quizzes intended to phish, scam, or deceive users.<br>
Use the Service to collect personal information without consent.<br>
Impersonate Bestiefy staff or make false claims of affiliation with Bestiefy.<br></p>
          <h2>8. Intellectual Property Rights</h2>
          <h3>8.1 Service Content</h3>
          <p>The Service and its original content (excluding user-generated content), features, and functionality are owned by Bestiefy and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
          <h3>8.2 Trademarks</h3>
          <p>Bestiefy, the Bestiefy logo, and other marks are trademarks of Bestiefy. You may not use these trademarks without our prior written permission.</p>
          <h3>8.3 Feedback</h3>
          <p>If you provide us with any feedback, suggestions, or ideas about the Service, you grant us the right to use such feedback without any obligation to you.</p>
          <h3>9. Advertising</h3>
          <p>The Service is supported by advertising. By using the Service, you agree that we and our advertising partners may display advertisements on the Service. You may not interfere with or block advertisements displayed on the Service.</p>
          <h3>10. Third-Party Services and Links</h3>
          <p>The Service may contain links to third-party websites or services that are not owned or controlled by Bestiefy. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that we shall not be responsible or liable for any damage or loss caused by or in connection with the use of any such content, goods, or services available on or through any such websites or services.</p>

          <h2>11. Termination</h2>
          <h3>11.1 By You</h3>
          <p>You may stop using the Service at any time. If you have created quizzes, you may delete them through the Service.</p>
          <h3>11.2 By Us</h3>
          <p>We reserve the right to suspend or terminate your access to the Service at any time, without notice, for any reason, including if we believe you have violated these Terms. Upon termination, your right to use the Service will immediately cease.</p>
          <h3>11.3 Effect of Termination</h3>
          <p>Upon termination, we may delete any content associated with your use of the Service. We are not obligated to retain any content after termination.</p>
          <h2>12. Disclaimers</h2>
          <h3>12.1 "As Is" Basis</h3>
          <p>THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR COURSE OF PERFORMANCE.</p>
          <h3>12.2 No Guarantee</h3>
          <p>Bestiefy does not warrant that:<br><br>

The Service will function uninterrupted, secure, or available at any particular time or location.<br>
Any errors or defects will be corrected.<br>
The Service is free of viruses or other harmful components.<br>
The results of using the Service will meet your requirements.<br></p>

          <h3>12.3 User Content</h3>
          <p>We do not review, verify, or endorse user-generated content. We make no warranties regarding the accuracy, reliability, or quality of any content created by users.</p>

          <h2>13. Limitation of Liability</h2>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL BESTIEFY, ITS AFFILIATES, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:<br><br>

Your access to or use of or inability to access or use the Service.<br>
Any conduct or content of any third party on the Service.<br>
Any content obtained from the Service.<br>
Unauthorized access, use, or alteration of your content.<br><br>

OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATING TO THE SERVICE SHALL NOT EXCEED ONE HUNDRED U.S. DOLLARS ($100).<br><br>

Some jurisdictions do not allow the exclusion of certain warranties or the limitation of liability for incidental or consequential damages. Accordingly, some of the limitations above may not apply to you.</p>

          <h2>14. Indemnification</h2>
          <p>You agree to defend, indemnify, and hold harmless Bestiefy, its affiliates, and their respective directors, officers, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with:<br><br>

Your access to or use of the Service.<br>
Your Content.<br>
Your violation of these Terms.<br>
Your violation of any rights of another party.<br></p>

          <h2>15. DMCA Copyright Policy</h2>
          <p>We respect the intellectual property rights of others. If you believe that any content on the Service infringes your copyright, please contact us at bestiefy@gmail.com with the following information:<br><br>

A description of the copyrighted work you claim has been infringed.<br>
A description of where the allegedly infringing material is located on the Service.<br>
Your contact information (address, telephone number, and email address).<br>
A statement that you have a good faith belief that the disputed use is not authorized by the copyright owner.<br>
A statement, under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.<br>
Your electronic or physical signature.<br><br>

We will investigate and take appropriate action, which may include removing the allegedly infringing content.</p>

          <h2>16. Dispute Resolution and Governing Law</h2>
          <h3>16.1 Governing Law</h3>
          <p>These Terms shall be governed by and construed in accordance with the laws of Colombia, without regard to its conflict of law provisions.</p>
          <h3>16.2 Dispute Resolution</h3>
          <p>Any disputes arising out of or relating to these Terms or the Service shall be resolved through good faith negotiations. If negotiations fail, disputes shall be subject to the exclusive jurisdiction of the courts of Colombia.</p>

          <h2>17. Severability</h2>
          <p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall continue in full force and effect. The invalid or unenforceable provision shall be replaced with a valid provision that most closely matches the intent of the original provision.</p>

          <h2>18. Waiver</h2>
          <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. Any waiver of any provision of these Terms will be effective only if in writing and signed by us.</p>

          <h2>19. Entire Agreement</h2>
          <p>These Terms, together with our Privacy Policy, constitute the entire agreement between you and Bestiefy regarding the use of the Service and supersede any prior agreements between you and Bestiefy relating to your use of the Service.</p>

          <h2>20. Assignment</h2>
          <p>You may not assign or transfer these Terms or your rights under these Terms without our prior written consent. We may assign these Terms without restriction.</p>

          <h2>21. Contact Information</h2>
          <p>If you have any questions about these Terms, please contact us at:<br><br>
Email: bestiefy@gmail.com<br>
Website: bestiefy.com</p>

          <hr style="margin: 40px 0; border: 1px solid #ddd;">

            <p>
By using Bestiefy, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</p>
            







            <!-- <h4>Interest-Based Advertising</h4>
            <h3>Advertising</h3>
            <p>
              This Site is affiliated with CMI Marketing, Inc., d/b/a Raptive (“Raptive”) for the purposes of placing advertising on the Site, and Raptive will collect and use certain data for advertising purposes. To learn more about Raptive’s data usage, click here: <a href="https://www.cafemedia.com/publisher-advertising-privacy-policy" target="_blank" rel="noreferrer noopener">https://www.cafemedia.com/publisher-advertising-privacy-policy</a>
            </p>
            <h3>Changes to the Privacy Policy</h3>
            <p>
              We may change this Privacy Policy from time to time. The most recent version of the Privacy Policy will always be posted on the Site, with the "Effective Date" posted at the top of the Policy. We may revise and update this Privacy Policy if our practices change, as technology changes, or as we add new services or change existing ones. If we make any material changes to our Privacy Policy or how we handle your personal information, or we are going to use any personal information in a manner that is materially different from that stated in our Privacy Policy at the time we collected such information, we will give you a reasonable opportunity to consent to the change. If you do not consent, your personal information will be used as agreed to under the terms of the privacy policy in effect at the time we obtained that information. By using our Site or services after the Effective Date, you are deemed to consent to our then-current privacy policy. We will use information previously obtained in accordance with the Privacy Policy in effect when the information was obtained from you.
            </p>
            <h3>Contacting Us</h3>
            <p>
              If you have any questions about this Privacy Policy, or the practices of this Site, please contact us at <b>bestiefy@gmail.com</b>
            </p> -->

            <!-- old -->
            <!-- <div id="playwire-policy">
              <h3>Common ID Cookie</h3>

              <p id="cookieP">This site uses cookies and similar tracking technologies such as the Common ID cookie to provide its services. Cookies are important devices for measuring advertising effectiveness and ensuring a robust online advertising industry. The Common ID cookie stores a unique user id in the first party domain and is accessible to our ad partners. This simple ID that can be utilized to improve user matching, especially for delivering ads to iOS and MacOS browsers. Users can opt out of the Common ID tracking cookie by clicking <a onclick="window.setCookie('_pubcid_optout', '1', 1825);" href="#opt-out">here</a>.</p>

              <h3>Advertising Privacy Settings</h3>
              <p>FOR EU USERS ONLY: When you use our site, pre-selected companies may access and use certain information on your device and about your interests to serve ads or personalized content. You may revisit or change consent-choices at any time by clicking <a href="#cmp" onclick="if(window.__cmp === undefined){console.warn('User is not in the EU - Consent Choices can only be configured when User is in the EU')}else{window.__cmp('showConsentTool')}" >here</a>.</p>
            </div> -->
          </center>
        </div>
        <div
          id="div_delete_button"
          class="delete_button_shadow go_back_button"
        >
          <button
            id="backButton"
            class="fullWidthButton button_2 pushdown "
            type="button"
            @click="goBack()"
          >
            {{ $t("answers.back") }}
          </button>
        </div>
      </div>
    </template>
    <FlyCompo />
    <FooterCompo />
  </div>
</template>

<script>
import HeaderCompo from '@/components/HeaderCompo.vue'
import FooterCompo from '@/components/FooterCompo.vue'
import FlyCompo from '@/components/FlyCompo.vue'
// import postscribe from 'postscribe'

export default {
  name: 'Privacy',
  components: {
    HeaderCompo,
    FooterCompo,
    FlyCompo
  },
  mounted: function () {
    // eslint-disable-next-line no-useless-escape
    // postscribe('#playwire-policy', `<script type="text/javascript">let optOutCounter = 0; function setCookie(cname,cvalue,exdays){var d = new Date();d.setTime(d.getTime()+(exdays*24*60*60*1000));var expires='expires='+d.toUTCString();document.cookie=cname+'='+cvalue+';'+expires+';path=/'; if(optOutCounter==0){ let cookieP = document.getElementById('cookieP'); var successCookie = document.createElement('h3'); successCookie.innerHTML = 'Optout Success!'; successCookie.setAttribute('style','color:green'); cookieP.appendChild(successCookie); optOutCounter ++ } };<\/script>`)
    // postscribe('#ad2', `<script src="//api.grumft.com/gt/ZONA_IAB_300x250/19f2a21e78f6b01bfc8138025537772e.js"><\/script>`)
  },
  methods: {
    goBack () {
      window.location.href = '/'
    }
  }
}
</script>

<style>
  a { word-wrap: break-word}
  .box.about center p { padding-top: 0; line-height: 140%;}
  h3 { margin: 30px 0 20px; font-size: 18px; }
  h2 { margin: 30px 0 20px; font-size: 20px;color: #747d8c !important; }
</style>
